import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Note';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 5.25C4.5 4.83579 4.83579 4.5 5.25 4.5H18.75C19.1642 4.5 19.5 4.83579 19.5 5.25V14.1493C19.5 14.3425 19.4254 14.5283 19.2918 14.6679L17.0305 17.0305L14.7803 19.2803C14.6397 19.421 14.4489 19.5 14.25 19.5H5.25C4.83579 19.5 4.5 19.1642 4.5 18.75V5.25ZM6 6V18H13.5V14.25C13.5 13.8358 13.8358 13.5 14.25 13.5H18V6H6ZM16.8976 15H15V16.9393L15.9639 15.9755L16.8976 15Z" fill="currentColor"/>
  </svg>
`;

const NoteIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.5 5.25C4.5 4.83579 4.83579 4.5 5.25 4.5H18.75C19.1642 4.5 19.5 4.83579 19.5 5.25V14.1493C19.5 14.3425 19.4254 14.5283 19.2918 14.6679L17.0305 17.0305L14.7803 19.2803C14.6397 19.421 14.4489 19.5 14.25 19.5H5.25C4.83579 19.5 4.5 19.1642 4.5 18.75V5.25ZM6 6V18H13.5V14.25C13.5 13.8358 13.8358 13.5 14.25 13.5H18V6H6ZM16.8976 15H15V16.9393L15.9639 15.9755L16.8976 15Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: NoteIcon,
  IconSvg: IconSvg
} as IconType;
